/**
 * 認証ハブの実行環境判定（開発 vs 本番）
 * - 開発環境用URLを使う条件: -dev / staging を含む / localhost または 192.168.x 等
 */

const PRIVATE_IP_RE = /^(10\.\d{1,3}\.\d{1,3}\.\d{1,3}|172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}|192\.168\.\d{1,3}\.\d{1,3})$/;

/**
 * 現在のアプリの実行URLが「開発環境」とみなす条件かどうか
 */
export const isDevHubContext = () => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname || '';
  const lower = host.toLowerCase();
  if (lower.includes('-dev')) return true;
  if (lower.includes('staging')) return true;
  if (host === 'localhost' || host === '127.0.0.1') return true;
  if (PRIVATE_IP_RE.test(host)) return true;
  return false;
};
